import React from "react";

const Loader = ({ size, color = "primary" }) => {
  if (size === "small") {
    if (color === "white") {
      return <div className="border-transparent border-2 border-l-white animate-spin h-4 w-4 rounded-full" role="status" />;
    }
    return (
      <div className="flex justify-center items-center h-full">
        <div className="border-primary border-2 border-l-primary animate-spin h-4 w-4 rounded-full" role="status" />
      </div>
    );
  }
  if (color === "white") {
    return <div className="border-transparent border-4 border-l-white animate-spin w-12 h-12 rounded-full" role="status" />;
  }
  return (
    <div className="flex justify-center items-center h-full">
      <div className="border-white border-4 border-l-primary animate-spin w-12 h-12 rounded-full" role="status" />
    </div>
  );
};

export default Loader;
